export default __webpack_public_path__ + "static/media/network_image.c15d8040.png";